module.exports = __webpack_public_path__ + "static/media/internacional-de-seguros-logo.6e1dc494.svg";